import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface AssociateUserWithCoachParams {
	readonly coachId: string;
}

@Injectable({ providedIn: 'root' })
export class AssociateUserWithCoachApiMutation extends ApiMutation<
	UserOutput,
	AssociateUserWithCoachParams
> {
	client = 'iam';
	document = gql`
		mutation AssociateUserWithCoach($coachId: UUID!) {
			associateUserWithCoach(coachId: $coachId) {
				...User
			}
		}
		${user}
	`;
	method = 'associateUserWithCoach';
}
